/**
 * ClaudeDocs — static data + nav types (non-component exports).
 *
 * Split out of components.tsx so the component module only exports
 * components (react-refresh). Values are verbatim from the original
 * ../ClaudeDocs.tsx.
 */

export interface NavSection {
  readonly id: string;
  readonly label: string;
}

export const SECTIONS: ReadonlyArray<NavSection> = [
  { id: 'overview', label: 'Overview' },
  { id: 'quickstart', label: 'Quick start' },
  { id: 'device', label: 'Sign in from your AI tool (no key)' },
  { id: 'oauth', label: 'OAuth 2.0 (recommended)' },
  { id: 'plugin', label: 'Claude Code plugin' },
  { id: 'desktop', label: 'Claude Desktop' },
  { id: 'cli', label: 'bbx CLI' },
  { id: 'tools', label: 'MCP tool reference' },
  { id: 'gating', label: 'Per-merchant gating' },
  { id: 'aliases', label: 'Aliases (custom names)' },
  { id: 'skills', label: 'Custom skills (Agency)' },
  { id: 'quotas', label: 'Quotas & rate limits' },
  { id: 'safety', label: 'Safety & undo window' },
  { id: 'troubleshooting', label: 'Troubleshooting' },
];
